import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Badge, Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon, Flag as FlagIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import QuestionReportCreate from './QuestionReportCreate';
import QuestionReportEdit from './QuestionReportEdit';
import apiProfileSlice from '../features/api/rest/apiProfileSlice';
import { useListQuestionAbuseReportsQuery } from '../features/api/rest/apiQuestionsReportsSlice';

function QuestionReport({ questionId, owner }) {
  const { ean } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [showModal, setShowModal] = React.useState(false);
  const { data: fetchedReports } = useListQuestionAbuseReportsQuery({ ean, questionId });
  const { user } = apiProfileSlice.endpoints.getProfile.useQueryState(undefined, {
    selectFromResult: ({ currentData }) => ({
      user: currentData?.username,
    }),
  });

  const handleClick = () => {
    if (!fetchedReports || !user) {
      navigate('/login', { state: { next: `${location.pathname}${location.search}` } });
      return;
    }
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <>
      {user !== owner && (
        <Badge color="error" variant="dot" sx={{ position: 'absolute', bottom: 10, right: 10 }} invisible={!fetchedReports?.length > 0}>
          <FlagIcon sx={{ color: 'grey.400', cursor: 'pointer' }} onClick={handleClick} fontSize="small" />
        </Badge>
      )}
      <Dialog open={showModal} onClose={() => setShowModal(false)} maxWidth="lg" fullWidth>
        <DialogContent>
          {fetchedReports?.length !== 8 && (
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {t('reports.create.heading', { what: 'question' })}
              </Typography>
              <QuestionReportCreate questionId={questionId} />
            </Box>
          )}
          {fetchedReports?.length > 0 && (
            <Box>
              <Typography variant="h6" sx={{ mt: 2 }}>
                {t('reports.edit.heading')}
              </Typography>
              <QuestionReportEdit questionId={questionId} owner={owner} />
            </Box>
          )}
        </DialogContent>
        <IconButton onClick={handleCancel} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
      </Dialog>
    </>
  );
}

QuestionReport.propTypes = {
  questionId: PropTypes.number.isRequired,
  owner: PropTypes.string.isRequired,
};

export default QuestionReport;
